module.exports = __webpack_public_path__ + "img/pups01.6069d5f2.jpg";